import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { PageHeader } from "@/components/ui/page-header";

import {
  AgreementDataTable,
  ContainerHeader,
  FormAgreements,
} from "@/components/common";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { EmptyState } from "@/components/ui/empty-state";
import { useFetchAgreementsQuery } from "@/hooks";
import { Skeleton } from "@/components/ui/skeleton";

export function Agreements() {
  const { t } = useTranslation();

  const [search, setSearch] = useState<string>("");

  // const navigate = useNavigate();
  // const { checkPermission } = usePermission();

  const {
    data: allCovenantData,
    isLoading,
    refetch,
  } = useFetchAgreementsQuery({ search });

  useEffect(() => {
    // if (!checkPermission("convenants", "view convenants")) {
    //   navigate("/")
    //   return;
    // }
    refetch();
  }, [search, refetch]);
  return (
    <section className="space-y-7">
      <div className="space-y-5">
        <PageHeader
          eyebrow="Clínica"
          title={t("LABEL.agreements")}
          lede="Os planos e convênios que a clínica atende, para vincular ao paciente e ao orçamento."
          actions={
            <FormAgreements>
              <Button variant="petrol" size="lg" className="px-5"
              // disabled={!checkPermission("convenants", "create convenants")}
              >{t("LABEL.new")}</Button>
            </FormAgreements>
          }
        />

        <ContainerHeader>
          <Input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            type="search"
            aria-label="Pesquisar convênios"
            placeholder="Pesquisar"
            showError={false}
          />
        </ContainerHeader>
      </div>

      <div className="space-y-2">
        {!allCovenantData || isLoading ? (
          <Skeleton className="w-full h-[500px]" />
        ) : allCovenantData.items.length === 0 ? (
          // C-11: the screen entered the menu, so it says what it is for.
          <EmptyState
            title="Nenhum convênio cadastrado"
            description="Cadastre aqui os planos e convênios que a clínica atende, para vinculá-los ao paciente e aos orçamentos."
            action={
              <FormAgreements>
                <Button className="px-10">{t("LABEL.new")}</Button>
              </FormAgreements>
            }
          />
        ) : (
          <AgreementDataTable data={allCovenantData} />
        )}
      </div>
    </section>
  );
}
